'use strict';

import AlertManager from "../../helpers/AlertManager";

export default class Alerts extends AlertManager {
  constructor(apiUrl, el, storageKey) {
    super(apiUrl, el, storageKey);
    this.initialize();
  }

  async initialize() {
    await this.processAlerts();
    if (this.alert) {
      this.displayAlert();
      let self = this;
      

      this.el.on('click', '.close', function (e) {
        e.preventDefault();
        self.handleAlertClose(self.alert.id);
        self.el.find('.alert-wrapper').fadeOut();
      });
    }

  }

  displayAlert() {
    this.el.html(`<div class='alert-wrapper'>
        <div class='flex gap-small container-small items-center'>
          ${this.alert.message}
          <a href="#" class='close' data-this.alert-id='${this.alert.alert_id}'><i class='icon icon-multiply'></i></a>
        </div>
      </div>`);
  }
}
